<template>
   <div class="contact-form-container">
      <h2>{{$t('pages.main.contactForm.title')}}</h2>
      <label for="name">{{$t('pages.main.contactForm.name')}}</label>
      <input type="text" id="name" v-model="userName"/>
      <label for="email">{{$t('pages.main.contactForm.email')}}</label>
      <input type="text" id="email" v-model="userEmail"/>
      <label for="message">{{$t('pages.main.contactForm.message')}}</label>
      <textarea id="message" v-model="message"></textarea>
      <div>
         <input id="agree" type="checkbox" v-model="agree">
         <label for="agree">{{$t('pages.main.contactForm.agree')}}  <router-link class="router-link-terms" title="terms" tag="a"
                                                       :to="{ name: 'termsAndConditions'}">
            {{$t('pages.main.contactForm.terms')}}&nbsp;&rarr;
         </router-link></label>
      </div>
      <p>{{response}}</p>
      <button v-on:click="send" :disabled="agree !== true">{{$t('pages.main.contactForm.send')}}</button>
   </div>
</template>

<script>
    export default {
        name: "MainPageContactForm",
        props: {
            userName: String,
            userEmail: String,
            message: String,
            submitting: Boolean,
            response: String
        },
        data: function () {
            return {
                agree: false
            }
        },
        methods: {
            async send() {
                this.submitting = true;
                try {
                    const formData = new FormData();
                    formData.append('name', this.userName);
                    formData.append('email', this.userEmail);
                    formData.append('text', this.message);

                    let response = await window.fetch(`${window.oneblendingHostApi}/feedback/post`, {
                        method: 'POST',
                        mode: 'cors',
                        body: formData
                    });

                    if (response.status === 200) {
                        let data = await response.json();
                        this.response = `message sent. Registered #${data.id}`;
                    } else if (response.status !== 200) {
                        this.response = "message not sent. Try again later"
                    }
                } finally {
                    this.submitting = false;
                }

            }
        }
    }
</script>

<style scoped lang="scss">
   @import "../../../theme/theme";

   .contact-form-container {
      display: grid;
      grid-gap: 0.6em;
      align-self: start;

      h2 {
         font-weight: normal;
         font-size: 1.6rem;
         text-align: justify;
         color: $primary20;
         padding-top: 3rem;
      }

      label {
         color: $text80;
         font-size: 0.9rem;
      }

      input {
         padding: 0.2em 0.6em;
         font-size: 1.1rem;
         border-width: 1px;
         border-color: $text40;
         background-color: $back20;
         color: $text100;
         border-style: solid;
         border-radius: 0.3em;
      }

      input:focus {
         border-color: $primary60;
         outline: none;
      }

      textarea {
         padding: 0.2em 0.6em;
         font-size: 1.1rem;
         border-width: 1px;
         border-color: $text40;
         background-color: $back20;
         color: $text100;
         border-style: solid;
         border-radius: 0.3em;
         height: 6em;
      }

      textarea:focus {
         border-color: $primary60;
         outline: none;
      }

      input[type=checkbox] {
         margin-right: 0.5rem;
      }

      button {
         margin-right: 1em;
         padding: 0.7em 2em;
         background: $primary100;
         border-radius: 0.4em;
         border-color: $back20;
         border-width: 1px;
         border-style: solid;
         text-decoration: none;
         text-effect: none;
         font-size: 1em;
         cursor: pointer;
         color: $primaryText100;
         justify-self: right;
         outline: none;
      }


      button:hover {
         background: $primary40;
      }

      button:disabled,
      button[disabled] {
         background: $back60;
      }
      a {
         font-size: 0.9rem;
         color: $text100;
         text-decoration: none;
         text-effect: none;
         cursor: pointer;
         margin-top: 0.5rem;
         margin-right: 3rem;
         border-bottom: 1px solid $primaryText100;
      }

      a:hover {
         //background: $primary40;
         border-bottom: 1px solid $text60;
         color: $text80;
      }
   }

</style>